import PrivateRoute from '@/modules/auth/components/PrivateRoute';
import { ReactNode } from 'react';
import { RouteObject } from 'react-router-dom';

export interface RouteEntry {
  path: string;
  component?: () => ReactNode;
  exact?: boolean;
  routes?: RouteEntry[];
  withAuth?: boolean;
}

const routesConfigurationMap =
  () =>
  (route: RouteEntry): RouteObject => {
    const {
      path,
      component: Component,
      exact = true,
      routes,
      withAuth,
    } = route;

    const resolvedPath = [path.startsWith('/') ? path.substring(1) : path];

    if (!exact) resolvedPath.push('*');

    const reactRouter: RouteObject = {
      path: resolvedPath.join('/'),
    };

    if (Component && !routes) {
      reactRouter.element = withAuth ? (
        <PrivateRoute>
          <Component />
        </PrivateRoute>
      ) : (
        <Component />
      );
    }

    if (routes) {
      reactRouter.children = routes.map(routesConfigurationMap());
    }

    return reactRouter;
  };

export const buildRouterConfiguration = (config: RouteEntry[]) =>
  config.map(routesConfigurationMap());
